export enum RestoreEntranceSetWarnigTypes {
  DEVICE_NOT_EXISTS = 'DEVICE_NOT_EXISTS',
  ENTRANCE_NOT_EXISTS = 'ENTRANCE_NOT_EXISTS',
}
